import { isString } from 'lodash'
import { User } from '../../user'

interface CreateDLRootCertificateInput {
  pem: string
}

interface UpdateDLRootCertificateInput {
  pem: string
}

export class DLRootCertificate {
  id: string
  
  name: string
  pem: string

  createdAt: number
  createdBy: User
  updatedAt: number
  updatedBy: User

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.createdBy) {
      this.createdBy = new User(this.createdBy);
    }

    if(this.updatedBy) {
      this.updatedBy = new User(this.updatedBy);
    }
  }

  get valid():boolean {
    // pem
    if(!isString(this.pem)) {
      return false;
    }

    let trimmedPem = this.pem.trim();

    if(trimmedPem.length < 1) {
      return false;
    }

    return true;
  }

  toCreateDLRootCertificateInput(): CreateDLRootCertificateInput {
    return {
      pem: this.pem,
    };
  }

  toUpdateDLRootCertificateInput(): UpdateDLRootCertificateInput {
    return {
      pem: this.pem,
    };
  }
}
